import { memo } from "react";

import { formatTimeForCounter } from "@zenith/utils";

/**
 * Props for Otp Countdown Component.
 * @interface
 * @name OtpCountdownProps
 * @kind interface
 */
interface OtpCountdownProps {
  /**
   * Seconds for the countdown.
   * @property
   * @name seconds
   * @kind property
   * @memberof OtpCountdownProps
   * @type {number}
   */
  seconds: number;
}

/**
 * Memoized Otp Countdown Component.
 * @constant
 * @name OtpCountdownComponent
 * @kind variable
 * @type {React.NamedExoticComponent<OtpCountdownProps>}
 */
const OtpCountdownComponent: React.NamedExoticComponent<OtpCountdownProps> =
  memo(
    /**
     * Otp Countdown Component.
     * @function
     * @name OtpCountdownComponent
     * @kind function
     * @memberof OtpCountdownComponent
     * @param {OtpCountdownProps} props Props for Otp Countdown Component.
     * @returns {JSX.Element} Otp Countdown Component.
     */
    function OtpCountdownComponent(props: OtpCountdownProps): JSX.Element {
      const { seconds } = props;

      return (
        <span>
          Request another OTP in{" "}
          <strong>{formatTimeForCounter(seconds)}</strong>
        </span>
      );
    }
  );

export default OtpCountdownComponent;
